import React from 'react';
import { isEditorActive, RichText, Text, withSitecoreContext } from '@sitecore-jss/sitecore-jss-react';
import { FindDealerModel } from './model/findDealer.model';
import { FindDealerProps } from './types/findDealer.types';
import Breakpoints from '../../constants/breakpoints.constants';
import useMediaQuery from '../../hooks/useMediaQuery';
import CTA from '../@shared/CTA';
import ctaTypes from '../../enums/CTA.enums';
import Picture from '../@shared/picture';
import UnreleasedComponent from '../@shared/unreleasedComponent';
import { targetLinkdsk } from '../../utils/targetDskLink';
import './styles.scss';

const FindDealer: React.FC = (props: FindDealerProps) => {
  const model = new FindDealerModel(props);
  const isEE = isEditorActive();
  const isWide = useMediaQuery(`(min-width: ${Breakpoints['tbl-p']}px)`);
  const imgAlt = isWide ? model.backgroundImage?.value?.alt : model.backgroundImageMobile?.value?.alt;

  // Component is unreleased
  if (model.isUnreleased) {
    return <UnreleasedComponent />;
  }

  if (!model.dataSource) return <></>;

  return (
    <>
      <div className="find-a-dealer-wrapper">
        <div className="find-a-dealer">
          <div className="find-a-dealer__bg-image-wrapper">
            <Picture
              editorialImageProps={{
                id: props.rendering?.dataSource,
                mobileImage: model?.mobileBgImage,
                desktopImage: model?.desktopBgImage,
                cssClassImageEl: 'find-a-dealer__bg-image',
                desktopTransformation: 'Size1900',
                mobileTransformation: 'Size1000',
                alt: `${imgAlt}`,
              }}
            />
          </div>
          <div className="find-a-dealer__container-wrapper">
            <div className="find-a-dealer__container">
              <Text field={model.title} tag={model.headingTag} className="find-a-dealer__text find-a-dealer__text--title" />
              <RichText tag="div" field={model.content} className="find-a-dealer__content rich-text" />
              {(isEE || (model?.link?.value?.text && model?.link?.value?.href)) && (
                <CTA
                  type={ctaTypes['primaryOrange']}
                  field={model.link}
                  target={targetLinkdsk(model?.link, isWide)}
                  extraClassName={'find-a-dealer__search-link'}
                />
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default withSitecoreContext()(FindDealer);
